import { makeStyles } from "@material-ui/core";
import React from "react";
import Card from './cardItems';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        ...theme.grid.gridMdContent,
        width: "63%",
        width: 1140,
        margin: "45px auto",
        maxWidth: '95%',
        '@media (max-width:1197px)': {
            width: 758,
        },
        '@media (max-width:600px)': {
            justifyContent: 'space-around',
        },
        '@media (max-width:421px)': {
            justifyContent: 'center',
        },
    }
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            {
                dataService?.map((item, index) => {
                    return (
                        <Card data={item} key={index} />
                    )
                })
            }
        </div>
    );
}


let dataService = [
    {
        title: "سامانه معاملات",
        desc: "آنلاین اکسیر",
        // icon: "/sprit.svg#service_ecxer",
        icon: "/assets/icons/service_ecxer.svg",
        link: "https://poyan.exirbroker.com",
        targetBlank: true
    },

    {
        title: "سامانه معاملات",
        desc: "آنلاین تدبیر",
        // icon: "/sprit.svg#service_ecxer",
        icon: "/assets/icons/service_classic.svg",
        link: "https://online.pouyanbroker.ir",
        targetBlank: true
    },
    {
        title: "اپلکیشن",
        desc: "تدبیر ",
        icon: "/assets/icons/app.svg",
        link: "https://online.pouyanbroker.ir",
        targetBlank: true
    },
    {
        title: "اپلکیشن",
        desc: "رایان همراه",
        icon: "/assets/icons/app.svg",
        link: "https://cafebazaar.ir/app/com.rh.ot.android",
        targetBlank: true
    },
    {
        title: "سامانه معاملات",
        desc: "آنلاین آتی",
        icon: "/assets/icons/service_ati.svg",
        link: "https://pouyan.exphoenixfuture.ir/login",
        targetBlank: true
    },
    {
        title: "سامانه معاملات",
        desc: "آنلاین کالا",
        icon: "/assets/icons/service_kala.svg",
        link: "https://pouyan.ebgo.ir/StockCode",
        targetBlank: true
    },

    // {
    //     title: "سامانه معاملات",
    //     desc: "آنلاین کلاسیک",
    //     icon: "/assets/icons/service_classic.svg",
    //     link: "https://poyan.irbroker.com",
    //     targetBlank: true
    // },
    // {
    //     title: "سامانه معاملات",
    //     desc: "آفلاین",
    //     icon: "/assets/icons/service_offline.svg",
    //     link: "https://poyan.irbrokersite.ir/",
    //     targetBlank: true
    // },




    // {
    //     title: "سامانه معاملات تدبیر",
    //     desc: "",
    //     icon: "system_online",
    //     link: "https://online.pouyanbroker.ir",
    //     targetBlank: true
    // },

    // {
    //     title: "رایان همراه (گوگل پلی)",
    //     desc: "",
    //     icon: "phone",
    //     link: "https://play.google.com/store/apps/details?id=com.rh.ot.android",
    //     targetBlank: true
    // },

    // {
    //     title: "آنلاین رایان همراه",
    //     desc: "",
    //     icon: "phone",
    //     link: "https://poyan.exirbroker.com/mobile/#view/login.html",
    //     targetBlank: true
    // },

]